/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/apps/common/js/aaFunctions.js
*    TO   --> ./webapps/shared-web/src/main/assets/js/legacy/utilities/aa-functions-print-page.js
**/

/* **************************
 * DEFUNCTED - left in place for backward compatibility
 * Use the functionality provided by aaGenericPopup
 * For any link wanting to open a printPreview page just add one of the
 * classname selectors used by aaGenericPopup to achieve the appropriate size window.
 * "aa-pop-win-med" comes closest to the size specified in this file.
 */
function printPage(pageName) {
    window.open(pageName, "Print",
        "scrollbars=yes,menubar=yes,resizable=yes,width=680,height=430,screenX=100,screenY=100,top=100,left=100");
}
